exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-container {\n  position: fixed;\n  width: 20%;\n  right: 1rem;\n  bottom: 0;\n  z-index: 2000;\n}\n@media screen and (max-width: 768px) {\n.alert-container .alert-container {\n      width: 40%;\n}\n}\n@media screen and (max-width: 576px) {\n.alert-container .alert-container {\n      width: 60%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32d8c815","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AlertContainer.vue
// module id = Yyr8
// module chunks = 15